import { useState, type ReactNode } from 'react';
import { Icon } from './Icon';

// Collapsible section headings on the Configuration screen (Bettina,
// 2026-11-02). Open/closed is remembered per browser; storage can be blocked,
// so every read and write is wrapped and the section simply defaults to open.
const storageKey = (id: string) => `afi-config-section:${id}`;

export function useSectionOpen(id: string): [boolean, () => void] {
  const [open, setOpen] = useState<boolean>(() => {
    try { return localStorage.getItem(storageKey(id)) !== 'closed'; } catch { return true; }
  });
  const toggle = () => setOpen((o) => {
    try { localStorage.setItem(storageKey(id), o ? 'closed' : 'open'); } catch { /* not remembered */ }
    return !o;
  });
  return [open, toggle];
}

export function SectionHeading({ open, onToggle, level = 2, children }: {
  open: boolean; onToggle: () => void; level?: 1 | 2; children: ReactNode;
}) {
  const Tag = level === 1 ? 'h1' : 'h2';
  return (
    <Tag style={{ margin: '4px 0 0', fontSize: level === 1 ? 22 : 18, fontWeight: 600 }}>
      <button type="button" onClick={onToggle} aria-expanded={open}
              title={open ? 'Collapse this section' : 'Expand this section'}
              style={{ all: 'unset', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        <Icon name={open ? 'chevdown' : 'chevright'} size={level === 1 ? 16 : 14} />
        {children}
      </button>
    </Tag>
  );
}
